<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import ExcelImport from "@/components/ExcelImport.vue";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Consumables",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    ExcelImport,
    DataTable,
  },

  data() {
    return {
      title: "Consumable",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Consumables",
          active: true,
        },
      ],
      totalRows: 1,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsConsumablesServerPaginated: true,
      serverPerPage: 50,
      filter: null,
      filterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "unit.name",
          sortable: true,
          label: "UNITS",
        },
        {
          key: "qty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "buying_price",
          sortable: true,
          label: "COST PRICE",
        },
        {
          key: "user.name",
          sortable: true,
          label: "ADDED By",
        },
        {
          key: "addedOn",
          sortable: true,
          label: "DATE ADDED",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      json_fields: {
        name: "name",
        unit: "unit",
        quantity: "quantity",
        minimum_quantity: "minimum_quantity",
        buying_price: "buying_price",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      nameError: "",
      unitError: "",
      qtyError: "",
      minQtyError: "",
      priceError: "",
      importError: "",
      importErrors: [],
      isImporting: false,
      importData: [],
      showImportModal: false,
      excelTemplateFields: {
        name: "name",
        unit: "unit",
        quantity: "quantity",
        minimum_quantity: "minimum_quantity",
        buying_price: "buying_price",
      },

      // Value from user input for adding category
      data: {
        name: "",
        unit: "",
        quantity: "",
        buying_price: "",
        minimum_quantity: "",
        page: 1,
        per_page: 50,
      },
      // edit unit
      editdata: {
        name: "",
        unit: "",
        quantity: "",
        buying_price: 0,
        minimum_quantity: 0,
        id: "",
      },
      // delete unit
      deletedata: {
        name: "",
        id: "",
      },
      validImportData: false,
      previewHeaders: [],
      excelRequiredHeaders: [
        "name",
        "unit",
        "quantity",
        "minimum_quantity",
        "buying_price",
      ],
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("products", ["Units"]),
    ...mapGetters("consumables", [
      "SaveStatus",
      "Consumables",
      "ConsumablesPagination",
      "ConsumablesPaginated",
    ]),
    ...mapGetters("auth", ["MyUserPerm"]),

    sampleImportData() {
      if (this.Consumables && this.Consumables.length > 0) {
        // Take first 2 consumables as samples, or all if less than 2
        return this.Consumables.slice(0, 2).map((consumable) => ({
          name: consumable.name,
          unit: consumable.unit?.name || "",
          quantity: consumable.qty,
          minimum_quantity: consumable.minimum_quantity,
          buying_price: consumable.buying_price,
        }));
      }
      return [];
    },

    rows() {
      return this.IsConsumablesServerPaginated
        ? this.ConsumablesPagination?.total
        : this.ConsumablesPaginated
        ? this.ConsumablesPaginated.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsConsumablesServerPaginated) {
          return this.ConsumablesPagination?.per_page || this.data.per_page;
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsConsumablesServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchConsumables(this.data);
        }
      },
    },

    currentPage: {
      get() {
        return this.ConsumablesPaginated && this.ConsumablesPagination
          ? this.ConsumablesPagination.current_page
          : 1;
      },
      set(value) {
        if (this.ConsumablesPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },

  watch: {
    show(newValue) {
      if (newValue) {
        if (this.type === "success") {
          Swal.fire("Success!", this.message.msg, "success");
          this.resetAdd();
          this.resetError();
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    importData(newData) {
      if (newData.length > 0) {
        this.validateImportData();
      }
    },
  },

  methods: {
    ...mapActions({
      AddItem: "consumables/addConsumables",
      EditItem: "consumables/editConsumables",
      DeleteConsumables: "consumables/deleteConsumables",
      FetchUnits: "products/fetchUnits",
      FetchConsumables: "consumables/fetchConsumables",
    }),

    commaSeparator() {
      this.data.buying_price = this.thousandSeperator(this.data.buying_price);
      this.editdata.buying_price = this.thousandSeperator(
        this.editdata.buying_price
      );
    },

    checkData() {
      if (this.data.name != "") {
        let Cons = this.Consumables.filter((item) => {
          return item.name == this.data.name;
        });
        let ConsCount = Cons.length;
        if (ConsCount > 0) {
          this.nameError =
            "Item with name " + this.data.name + "  already Exists";
        }
      }
    },
    checkEditData() {
      if (this.editdata.name != "") {
        let Cons = this.Consumables.filter((item) => {
          // return item.name == this.editdata.name;
          return item.name == this.editdata.name && item.id != this.editdata.id;
        });
        let ConsCount = Cons.length;
        if (ConsCount > 0) {
          this.nameError =
            "Item with name " + this.editdata.name + "  already Exists";
        }
      }
    },

    async addItem(modalId) {
      this.modal_id = modalId;
      // Validate the fields
      if (!this.validateFormData(this.data)) {
        return;
      }
      this.checkData();
      if (this.nameError) {
        return;
      }
      await this.AddItem(this.data).then(() => this.closeModal(modalId));
    },

    validateFormData(data) {
      this.resetError();
      let isValid = true;
      if (!data.name) {
        this.nameError = "Item name field is required";
        isValid = false;
      }
      if (!data.unit) {
        this.unitError = "Item units field is required";
        isValid = false;
      }
      if (!data.quantity) {
        this.qtyError = "Quantity is required";
        isValid = false;
      }
      if (!data.minimum_quantity) {
        this.minQtyError = "Minimum quantity is required";
        isValid = false;
      }
      if (!data.buying_price) {
        this.priceError = "Cost price field is required";
        isValid = false;
      }
      return isValid;
    },

    async editItem(modalId) {
      this.modal_id = modalId;
      // if (!this.validateFormData(this.editdata)) {
      //   return;
      // }
      this.checkEditData();
      if (this.nameError != "") {
        return this.nameError;
      }
      await this.EditItem(this.editdata).then(() => this.closeModal(modalId));
    },

    resetAdd() {
      this.data.name = "";
      this.data.unit = "";
      this.data.quantity = "";
      this.data.minimum_quantity = "";
      this.data.buying_price = "";
      this.resetError();
    },
    resetEdit() {
      this.editdata.name = "";
      this.editdata.unit = "";
      this.editdata.quantity = "";
      this.editdata.minimum_quantity = "";
      this.editdata.buying_price = "";
      this.editdata.id = "";
      this.resetError();
    },
    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
    },
    resetError() {
      this.nameError = "";
      this.unitError = "";
      this.qtyError = "";
      this.minQtyError = "";
      this.priceError = "";
      this.importError = "";
    },
    showEditModal(row) {
      this.editdata.name = row.name;
      this.editdata.quantity = row.qty;
      // this.editdata.unit = row.unit.name;
      this.editdata.unit = row.unit.id;
      this.editdata.buying_price = row.buying_price;
      this.editdata.minimum_quantity = row.minimum_quantity;
      this.editdata.id = row.id;
    },
    showDeleteModal(row) {
      this.deletedata.name = row.name;
      this.deletedata.id = row.id;
    },

    async deleteConsumables(modalId) {
      this.modal_id = modalId;
      await this.DeleteConsumables(this.deletedata).then(() => {
        this.closeModal(modalId);
        this.FetchConsumables(this.data);
      });
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
      if (modalId === "import-consumables-modal") {
        this.showImportModal = false;
        this.importData = [];
        this.resetError();
        this.validImportData = false;
        this.previewHeaders = [];
      }
    },

    redirect(value) {
      this.$router.push(`/consumables/movement/${btoa(value)}`);
    },

    thousandSeperator(m) {
      if (m !== "" && m !== undefined && m !== 0 && m !== "0" && m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return m;
    },

    // Use method to open import in order to first clear previous errors and previous import data
    openImportModal() {
      this.showImportModal = true;
      this.importData = [];
      this.resetError();
      this.importErrors = [];
      this.validImportData = false;
      this.previewHeaders = [];
    },
    validateImportData() {
      this.resetError();
      let errors = [];
      this.importData.forEach((item, index) => {
        const rowNum = index + 2; // account for header row
        if (!item.name || item.name.trim() === "") {
          errors.push(`Row ${rowNum}: Name is required.`);
        }
        if (!item.unit || item.unit.trim() === "") {
          errors.push(`Row ${rowNum}: Unit is required.`);
        }
        if (isNaN(item.quantity) || item.quantity < 0) {
          errors.push(`Row ${rowNum}: Quantity must be a non-negative number.`);
        }
        if (isNaN(item.minimum_quantity) || item.minimum_quantity < 0) {
          errors.push(
            `Row ${rowNum}: Minimum Quantity must be a non-negative number.`
          );
        }
        if (isNaN(item.buying_price) || item.buying_price < 0) {
          errors.push(
            `Row ${rowNum}: Buying Price must be a non-negative number.`
          );
        }
      });

      this.importErrors = errors;
      this.validImportData = errors.length === 0;
    },

    // Handle Excel import success
    handleExcelImportSuccess(result) {
      Swal.fire("Success!", result.message, "success");
      this.FetchConsumables();
      this.closeModal("import-consumables-modal");
    },

    // Handle Excel import error
    handleExcelImportError(error) {
      Swal.fire("Error!", error, "error");
    },

    // Custom validation for Excel import
    validateExcelData(data) {
      const errors = [];

      data.forEach((row, index) => {
        const rowNum = index + 2;

        // Check for duplicate names in the same import
        const duplicates = data.filter((item) => item.name === row.name);
        if (duplicates.length > 1) {
          errors.push(
            `Row ${rowNum}: Duplicate item name '${row.name}' found in import data`
          );
        }

        // Check if item already exists in database
        if (this.Consumables) {
          const existing = this.Consumables.find(
            (item) => item.name === row.name
          );
          if (existing) {
            errors.push(
              `Row ${rowNum}: Item '${row.name}' already exists in the system`
            );
          }
        }

        // Validate numeric fields
        if (isNaN(row.quantity) || row.quantity < 0) {
          errors.push(
            `Row ${rowNum}: Quantity must be a valid non-negative number`
          );
        }

        if (isNaN(row.minimum_quantity) || row.minimum_quantity < 0) {
          errors.push(
            `Row ${rowNum}: Minimum quantity must be a valid non-negative number`
          );
        }

        if (isNaN(row.buying_price) || row.buying_price < 0) {
          errors.push(
            `Row ${rowNum}: Buying price must be a valid non-negative number`
          );
        }
      });

      return errors;
    },

    handlePageChange(newPage) {
      if (this.IsConsumablesServerPaginated) {
        this.data.page = newPage;
        this.FetchConsumables(this.data);
      }
    },
  },

  created() {
    this.FetchUnits();
    this.FetchConsumables(this.data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-8">
                <h4 class="card-title">All Consumable Items</h4>
              </div>
              <div class="col-md-4" align="right">
                <b-button variant="info" class="me-2" @click="openImportModal">
                  <i class="fa fa-upload"></i> Import Items
                </b-button>
                <b-button
                  v-if="MyUserPerm.add_consumable_items == 1"
                  v-b-modal.add-item-modal
                  variant="primary"
                >
                  <i class="fa fa-plus"></i> Add New
                </b-button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="fields"
                :rows="Consumables || []"
                :total-rows="rows"
                :pagination="ConsumablesPagination"
                :server-pagination="IsConsumablesServerPaginated"
                :loading="SaveStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(name)="{ row }">
                  {{ row.name }}
                </template>
                <template #cell(unit.name)="{ row }">
                  {{ row.unit ? row.unit.name : "" }}
                </template>

                <template #cell(qty)="{ row }">
                  {{ thousandSeperator(row.qty ? row.qty : 0) }}
                </template>
                <template #cell(buying_price)="{ row }">
                  {{ row.buying_price ? row.buying_price.toLocaleString() : 0 }}
                </template>
                <template #cell(user.name)="{ row }">
                  {{ row.user ? row.user.name : "N/A" }}
                </template>
                <template #cell(addedOn)="{ row }">
                  {{ row.addedOn }}
                </template>
                <template #cell(actions)="{ row }">
                  <b-button-group>
                    <b-button
                      v-if="MyUserPerm.edit_consumables == 1"
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-item-modal
                      @click="showEditModal(row)"
                    >
                      <i class="fa fa-edit"></i> Edit
                    </b-button>
                    <b-button
                      size="sm"
                      variant="success"
                      @click="redirect(row.id)"
                    >
                      <i class="fa fa-retweet"></i> Movements
                    </b-button>
                    <b-button
                      v-if="MyUserPerm.delete_consumables == 1"
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-item-modal
                      @click="showDeleteModal(row)"
                    >
                      <i class="fa fa-trash"></i> Delete
                    </b-button>
                  </b-button-group>
                </template>
              </DataTable>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Item Modal -->
    <b-modal id="add-item-modal" hide-footer @hidden="resetAdd">
      <template #modal-title> Add New Item </template>
      <div class="form-group mb-3">
        <label>Item Name</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Item Name"
            class="form-control"
            @input="resetError()"
            v-model="data.name"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Units</label>
        <div class="input-group">
          <input
            class="form-control"
            v-model="data.unit"
            list="units"
            @keyup="checkData()"
            placeholder="Enter Product unit"
            autocomplete="off"
          />
          <datalist id="units">
            <option v-for="(cat, c) in Units" :data-value="cat.name" :key="c">
              {{ cat.symbol }}
            </option>
          </datalist>
        </div>
        <div class="text-danger" v-if="unitError">
          <em>{{ unitError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Quantity</label>
        <div class="input-group">
          <input
            type="number"
            placeholder="Enter Quantity"
            class="form-control"
            @input="resetError()"
            v-model="data.quantity"
          />
        </div>
        <div class="text-danger" v-if="qtyError">
          <em>{{ qtyError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Minimum Quantity</label>
        <div class="input-group">
          <input
            type="number"
            placeholder="Enter warning Quantity"
            class="form-control"
            @input="resetError()"
            v-model="data.minimum_quantity"
          />
        </div>
        <div class="text-danger" v-if="minQtyError">
          <em>{{ minQtyError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Buying Price</label>
        <div class="input-group">
          <input
            placeholder="Enter buying price"
            class="form-control"
            @input="resetError(), commaSeparator()"
            v-model="data.buying_price"
          />
        </div>
        <div class="text-danger" v-if="priceError">
          <em>{{ priceError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          @click="closeModal('add-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          v-if="SaveStatus"
          type="button"
          class="btn btn-primary"
          disabled
        >
          <i class="fa fa-check"></i> Submit
          <b-spinner variant="light" small label="Spinning"></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-primary"
          @click="addItem('add-item-modal')"
        >
          <i class="fa fa-check"></i> Submit
        </button>
      </div>
    </b-modal>

    <!-- Edit Item Modal -->
    <b-modal id="edit-item-modal" hide-footer @hidden="resetEdit()">
      <template #modal-title> Edit Consumable {{ editdata.name }}</template>
      <div class="form-group mb-3">
        <label>Item Name</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Item Name"
            class="form-control"
            @input="resetError()"
            v-model="editdata.name"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Units</label>
        <div class="input-group">
          <model-list-select
            :list="Units ? Units : []"
            v-model="editdata.unit"
            option-value="id"
            option-text="name"
            @input="resetError()"
            placeholder="Select Units"
          ></model-list-select>
        </div>
        <div class="text-danger" v-if="unitError">
          <em>{{ unitError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Quantity</label>
        <div class="input-group">
          <input
            type="number"
            placeholder="Enter Quantity"
            class="form-control"
            @input="resetError()"
            v-model="editdata.quantity"
          />
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Minimum Quantity</label>
        <div class="input-group">
          <input
            type="number"
            placeholder="Enter warning Quantity"
            class="form-control"
            @input="resetError()"
            v-model="editdata.minimum_quantity"
          />
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Buying Price</label>
        <div class="input-group">
          <input
            placeholder="Enter buying price"
            class="form-control"
            @input="resetError(), commaSeparator()"
            v-model="editdata.buying_price"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          @click="closeModal('edit-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          v-if="SaveStatus"
          type="button"
          class="btn btn-primary"
          disabled
        >
          <i class="fa fa-check"></i> Submit
          <b-spinner variant="light" small label="Spinning"></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-primary"
          @click="editItem('edit-item-modal')"
        >
          <i class="fa fa-check"></i> Submit
        </button>
      </div>
    </b-modal>

    <!-- Delete Item Modal -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-item-modal"
      hide-footer
      @hidden="resetDelete"
    >
      <template #modal-title>Delete Consumable {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this Consumable Item? Click Proceed Button to
            delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          @click="closeModal('delete-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteConsumables('delete-item-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>

    <!-- Import Consumables Modal -->
    <b-modal
      id="import-consumables-modal"
      v-model="showImportModal"
      title="Import Consumables"
      hide-footer
    >
      <template #modal-title>Import Consumables</template>
      <template>
        <ExcelImport
          :template-fields="excelTemplateFields"
          :sample-data="sampleImportData"
          template-filename="consumables_template.xlsx"
          upload-label="Select Excel file with consumable data:"
          import-url="consumables/import"
          :required-headers="excelRequiredHeaders"
          :custom-validation="validateExcelData"
          @import-success="handleExcelImportSuccess"
          @import-error="handleExcelImportError"
          @close-modal="closeModal('import-consumables-modal')"
        />
      </template>
    </b-modal>
  </Layout>
</template>

<style scoped>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
